import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router, UrlSegment } from '@angular/router';

import { RoutePaths } from '../shared/constants/route-paths.constant';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class M365AppsRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {

    private readonly m365AppsNavigationEnabled: boolean;
    private readonly mosAppAtRootEnabled: boolean;
    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(router, capabilitiesService);
        this.m365AppsNavigationEnabled = this.capabilitiesService.capabilities.leftNavReact && this.capabilitiesService.capabilities.m365AppsEnabled;
        this.mosAppAtRootEnabled = this.capabilitiesService.capabilities.mosAppHostedAtRootEnabled;
    }

    public canActivate(route: ActivatedRouteSnapshot) {
        return this.isMosAppAtRoot(route.url) ? this.checkEnabledAndRedirect(this.m365AppsNavigationEnabled && this.mosAppAtRootEnabled) : this.checkEnabledAndRedirect(this.m365AppsNavigationEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.m365AppsNavigationEnabled);
    }

    private isMosAppAtRoot(segments: Array<UrlSegment>): boolean {
        return segments.length && segments[0].path !== RoutePaths.M365Apps;
    }
}
